import React from 'react'
import TitleLockup, { TitleLockupProps } from '../title-lockup'
import { Button, BaseButtonProps } from '../button'
import * as styles from './ComponentTitleLockup.module.scss'

export interface ComponentTitleLockupProps extends TitleLockupProps {
  bodyText1?: string
  bodyText2?: string
  layout?: 'stacked' | 'twoColumnText' | 'twoColumnButton'
  align?: 'left' | 'center'
  maxWidth?: 'md' | 'sm' | 'full'
  buttonProps?: BaseButtonProps
  paragraphMargin?: boolean
  showHeadingDivider?: boolean
}

const ComponentTitleLockup: React.FC<ComponentTitleLockupProps> = ({
  bodyText1,
  bodyText2,
  layout = 'stacked',
  align = 'left',
  maxWidth,
  buttonProps,
  paragraphMargin = false,
  showHeadingDivider = false,
  ...titleLockupProps
}) => {
  const marginValue = paragraphMargin ? 'var(--space-md)' : '0'

  return (
    <div
      className={`${styles.container} ${styles[layout]} ${styles[align]} ${styles[maxWidth]}`}
    >
      <TitleLockup
        {...titleLockupProps}
        showHeadingDivider={showHeadingDivider}
      />
      <div>
        {bodyText1 && (
          <p
            className={`${styles[maxWidth]}`}
            style={{ marginBottom: marginValue }}
          >
            {bodyText1}
          </p>
        )}
        {bodyText2 && (
          <p
            className={`${styles[maxWidth]}`}
            style={{ marginBottom: marginValue }}
          >
            {bodyText2}
          </p>
        )}
        {buttonProps && <Button {...buttonProps} />}
      </div>
    </div>
  )
}

export default ComponentTitleLockup
